import {
  Building2,
  BriefcaseBusiness,
  Computer,
  Eye,
  Goal,
  Handshake,
  Hotel,
  Package,
  Printer,
  ShieldCheck,
  Sparkles,
  Truck,
  Users,
} from "lucide-react";

export const companyConfig = {
  nameAr: "مؤسسة جذر للتوريد التجارية",
  nameEn: "Jathr Al-Tawreed Al-Tijariah",
  phone: "0579389914",
  whatsapp: "https://wa.me/+966579389914",
  email: "GM@roottrade.sa",
  mapLink: "https://maps.app.goo.gl/sMqiqJsCXmGVRwkY8?g_st=com.google.maps.preview.copy",
  logoUrl: "/assets/logo-new.jpeg",
};

export const cleaningCatalogConfig = {
  pdfUrl: "/assets/cleaning-catalog.pdf",
  pagesFolder: "/assets/catalog-pages",
  pageCount: 62,
};

export const hospitalityCatalogConfig = {
  pdfUrl: "/assets/hospitality-catalog.pdf",
  pagesFolder: "/assets/hospitality-pages",
  pageCount: 11,
  hiddenPages: [1, 6],
};

const images = {
  hero:
    "https://images.unsplash.com/photo-1768796373552-1168cb598645?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  cleaning:
    "https://images.unsplash.com/photo-1626379481874-3dc5678fa8ca?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  hospitality:
    "/assets/hospitality-service.jpg",
  office:
    "https://images.unsplash.com/photo-1758630737361-ca7532fb5e7f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  warehouse:
    "https://images.unsplash.com/photo-1765696300043-142687b6b4a7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  catering:
    "https://images.unsplash.com/photo-1759769191172-49474943ee94?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  corporate:
    "https://images.unsplash.com/photo-1616147147027-60d49d3582c4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  devices:
    "https://static.prod-images.emergentagent.com/jobs/73138aef-a8b2-49b4-b582-6e86a5ef4e63/images/7b69fb6db8d9d6c0e0ecdd511bca82ce5a323776651dc89cd6880e874d86de79.png",
  vision2030:
    "https://customer-assets.emergentagent.com/job_saudi-jobs/artifacts/e1zm7zsp_WhatsApp%20Image%202026-03-04%20at%201.42.07%20AM.jpeg",
};

const services = [
  {
    key: "cleaning",
    icon: Sparkles,
    image: images.cleaning,
    titleAr: "مستلزمات النظافة والتعقيم",
    titleEn: "Cleaning & Sanitization Supplies",
    descriptionAr: "مواد تنظيف عامة، معقمات، وأدوات تنظيف متخصصة بجودة عالية للمنشآت.",
    descriptionEn: "Reliable cleaning products, disinfectants, and professional tools for facilities.",
  },
  {
    key: "hospitality",
    icon: Hotel,
    image: images.hospitality,
    titleAr: "لوازم الضيافة",
    titleEn: "Hospitality Essentials",
    descriptionAr: "توفير احتياجات الضيافة للفنادق والمكاتب والمناسبات بشكل احترافي.",
    descriptionEn: "High-quality hospitality products for hotels, offices, and events.",
  },
  {
    key: "office",
    icon: BriefcaseBusiness,
    image: images.office,
    titleAr: "القرطاسية واللوازم المكتبية",
    titleEn: "Office & Stationery Supplies",
    descriptionAr: "حلول مكتبية متكاملة للشركات والمنشآت التجارية باحترافية.",
    descriptionEn: "Comprehensive office and stationery procurement for business operations.",
  },
  {
    key: "devices",
    icon: Computer,
    image: images.devices,
    titleAr: "أجهزة الحاسب والطابعات وملحقاتها",
    titleEn: "Computers, Printers & Accessories",
    descriptionAr: "نوفر أجهزة الحواسب والطابعات وكل ما يلزمها من موارد تشغيل مثل الحبر والورق والملحقات.",
    descriptionEn: "We provide computers, printers, and all related operating resources such as ink, paper, and essential accessories.",
  },
  {
    key: "logistics",
    icon: Truck,
    image: images.warehouse,
    titleAr: "توريد سريع ومرن",
    titleEn: "Fast & Flexible Supply",
    descriptionAr: "سرعة في التوريد ومرونة عالية لتلبية الطلبات الكبيرة والمتكررة.",
    descriptionEn: "Flexible and responsive supply chain for recurring or bulk requirements.",
  },
  {
    key: "quality",
    icon: ShieldCheck,
    image: images.corporate,
    titleAr: "ضمان الجودة",
    titleEn: "Quality Assurance",
    descriptionAr: "منتجات موثوقة من أفضل الموردين مع التزام بمعايير الجودة والسلامة.",
    descriptionEn: "Trusted sourcing from top suppliers with strict quality and safety standards.",
  },
];

const sectors = [
  {
    key: "companies",
    icon: Building2,
    titleAr: "الشركات والمكاتب",
    titleEn: "Companies & Offices",
    descriptionAr: "عقود توريد دورية لدعم بيئة عمل نظيفة ومنظمة.",
    descriptionEn: "Recurring supply contracts to maintain clean and productive workplaces.",
    image: images.office,
  },
  {
    key: "hospitality",
    icon: Hotel,
    titleAr: "الفنادق والضيافة",
    titleEn: "Hotels & Hospitality",
    descriptionAr: "حلول ضيافة ونظافة تعكس تجربة عملاء احترافية.",
    descriptionEn: "Hospitality-focused supplies to elevate guest experience and hygiene.",
    image: images.hospitality,
  },
  {
    key: "institutions",
    icon: Users,
    titleAr: "المنشآت التجارية",
    titleEn: "Commercial Facilities",
    descriptionAr: "تغطية شاملة للمتطلبات اليومية بأفضل سعر وجودة.",
    descriptionEn: "Comprehensive daily supply coverage with strong value and quality.",
    image: images.warehouse,
  },
];

export const getSiteContent = (language) => {
  const isArabic = language === "ar";

  const cleaningSectionGroups = [
    {
      key: "waste-management",
      title: isArabic ? "إدارة النفايات" : "Waste Management",
      startPage: 1,
      endPage: 8,
    },
    {
      key: "floor-care",
      title: isArabic ? "العناية بالأرضيات" : "Floor Care",
      startPage: 9,
      endPage: 25,
    },
    {
      key: "cleaning-chemicals",
      title: isArabic ? "مواد التنظيف الكيميائية" : "Cleaning Chemicals",
      startPage: 26,
      endPage: 29,
    },
    {
      key: "cloth-care",
      title: isArabic ? "العناية بالأقمشة" : "Cloth Care",
      startPage: 30,
      endPage: 34,
    },
    {
      key: "dispensers",
      title: isArabic ? "الموزعات" : "Dispensers",
      startPage: 35,
      endPage: 36,
    },
    {
      key: "health-safety",
      title: isArabic ? "الصحة والسلامة" : "Health & Safety",
      startPage: 37,
      endPage: 39,
    },
    {
      key: "household",
      title: isArabic ? "مستلزمات منزلية" : "House Hold",
      startPage: 40,
      endPage: 50,
    },
    {
      key: "hardware-tools",
      title: isArabic ? "معدات وأدوات" : "Hardware",
      startPage: 51,
      endPage: 54,
    },
    {
      key: "window-care",
      title: isArabic ? "العناية بالنوافذ" : "Window Care",
      startPage: 55,
      endPage: 58,
    },
    {
      key: "work-safety",
      title: isArabic ? "سلامة العمل" : "Work Safety",
      startPage: 59,
      endPage: 60,
    },
    {
      key: "pe-bags",
      title: isArabic ? "أكياس النفايات" : "PE Bags",
      startPage: 61,
      endPage: 62,
    },
  ];

  return {
    nav: [
      { to: "/", label: isArabic ? "الرئيسية" : "Home" },
      { to: "/about", label: isArabic ? "من نحن" : "About" },
      { to: "/services", label: isArabic ? "خدماتنا" : "Services" },
      { to: "/projects", label: isArabic ? "أعمالنا" : "Projects" },
      { to: "/contact", label: isArabic ? "تواصل معنا" : "Contact" },
    ],
    home: {
      badge: isArabic ? "توريد احترافي للشركات والمنشآت" : "Professional B2B Procurement",
      title: isArabic
        ? "حلول توريد متكاملة لمواد النظافة والضيافة بجودة موثوقة"
        : "Complete supply solutions for hygiene and hospitality with trusted quality",
      aboutSnippetTitle: isArabic ? "نبذة عنا" : "About Us",
      subtitle: isArabic
        ? "تعمل مؤسسة جذر التوريد التجارية على تقديم حلول متكاملة في توريد المتطلبات بمختلف أنواعها، بما يشمل الاحتياجات المكتبية، ومواد النظافة، والمستلزمات التشغيلية، والتجهيزات التقنية. نسعى من خلال خبرتنا وكفاءتنا إلى تلبية احتياجات عملائنا بدقة وسرعة وجودة عالية، مع التزام كامل بالمعايير المهنية المعتمدة داخل المملكة."
        : "Jathr Al-Tawreed Al-Tijariah provides integrated procurement solutions across office needs, cleaning materials, operational supplies, and technical equipment. Through our expertise and efficiency, we deliver speed, precision, and high quality with full adherence to professional standards in the Kingdom.",
      ctaPrimary: isArabic ? "اطلب عرض سعر" : "Request a Quote",
      ctaSecondary: isArabic ? "استكشف الخدمات" : "Explore Services",
      visionBannerTitle: isArabic ? "رؤية المملكة 2030" : "Saudi Vision 2030",
      visionBannerText: isArabic
        ? "نلتزم بتطوير خدمات التوريد ورفع كفاءة سلاسل الإمداد بما يدعم مستهدفات رؤية المملكة 2030."
        : "We continuously improve supply services and operational efficiency in alignment with Saudi Vision 2030 objectives.",
      visionBannerImage: images.vision2030,
      stats: [
        {
          value: "+120",
          label: isArabic ? "عميل أعمال" : "Business Clients",
        },
        {
          value: "24/7",
          label: isArabic ? "استجابة للطلبات" : "Request Responsiveness",
        },
        {
          value: "100%",
          label: isArabic ? "تركيز على الجودة" : "Quality Focus",
        },
      ],
      heroImage: images.hero,
    },
    about: {
      title: isArabic ? "من نحن" : "About Us",
      summary: isArabic
        ? "تعمل مؤسسة جذر التوريد التجارية على تقديم حلول متكاملة في توريد المتطلبات بمختلف أنواعها بما يشمل الاحتياجات المكتبية، ومواد النظافة، والمستلزمات التشغيلية، والتجهيزات التقنية."
        : "Jathr Al-Tawreed Al-Tijariah delivers integrated procurement solutions across office needs, cleaning supplies, operational requirements, and technical equipment.",
      summary2: isArabic
        ? "نسعى من خلال خبرتنا وكفاءتنا إلى تلبية احتياجات عملائنا بدقة، وسرعة، وجودة عالية، مع التزام كامل بالمعايير المهنية المعتمدة داخل المملكة."
        : "Through our expertise and efficiency, we fulfill client needs with precision, speed, and high quality while maintaining full compliance with professional standards in Saudi Arabia.",
      visionTitle: isArabic ? "رؤيتنا" : "Our Vision",
      visionText: isArabic
        ? "أن نكون الجهة الرائدة والموثوقة في توريد المتطلبات بجودة عالية وحلول متكاملة للقطاعين الحكومي والخاص داخل المملكة."
        : "To become the leading and most trusted provider of high-quality procurement solutions for both public and private sectors in the Kingdom.",
      missionTitle: isArabic ? "رسالتنا" : "Our Mission",
      missionText: isArabic
        ? "تقديم خدمات احترافية في توريد المتطلبات بمختلف أنواعها، مع الالتزام بالجودة، والسرعة في التنفيذ، والأسعار التنافسية، وبناء شراكات مستدامة مبنية على الثقة والمصداقية."
        : "To provide professional procurement services across all requirement categories with quality, fast execution, competitive pricing, and sustainable partnerships built on trust and credibility.",
      vision2030Title: isArabic ? "رؤية 2030" : "Vision 2030",
      vision2030Text: isArabic
        ? "تسعى مؤسسة جذر التوريد التجارية إلى دعم مستهدفات رؤية المملكة 2030 عبر:"
        : "Root Trade supports Saudi Vision 2030 objectives through:",
      vision2030Points: isArabic
        ? [
            "رفع كفاءة سلاسل الإمداد وتعزيز موثوقية عمليات التوريد.",
            "تبنّي حلول حديثة وتطوير الخدمات بما يتماشى مع التحول الرقمي.",
            "الإسهام في تعزيز التنافسية وجودة الخدمات المقدمة للقطاعين العام والخاص.",
            "دعم الاقتصاد الوطني من خلال تقديم خدمات توريد ذات معايير عالية.",
          ]
        : [
            "Improving supply chain efficiency and reliability.",
            "Adopting modern solutions aligned with digital transformation.",
            "Enhancing competitiveness and service quality for public and private sectors.",
            "Supporting the national economy through high-standard procurement services.",
          ],
      cards: [
        {
          icon: Handshake,
          title: isArabic ? "شراكة طويلة المدى" : "Long-Term Partnership",
          desc: isArabic ? "نحرص على بناء علاقة مستمرة مع كل عميل." : "We build sustainable and dependable client relationships.",
        },
        {
          icon: Printer,
          title: isArabic ? "موثوقية عالية" : "High Reliability",
          desc: isArabic
            ? "جودة ثابتة في المنتجات والموارد التشغيلية للأجهزة مثل الحبر والورق من موردين موثوقين."
            : "Consistent quality across products and device consumables like ink and paper from trusted suppliers.",
        },
        {
          icon: Package,
          title: isArabic ? "مرونة في الكميات" : "Bulk Flexibility",
          desc: isArabic ? "جاهزية لتلبية الطلبات الكبيرة والمتكررة." : "Built to fulfill recurring and high-volume requests.",
        },
      ],
    },
    services,
    sectors,
    homeIdentityBlocks: [
      {
        key: "mission",
        icon: Goal,
        title: isArabic ? "رسالتنا" : "Our Mission",
        text: isArabic
          ? "تقديم خدمات احترافية في توريد المتطلبات بمختلف أنواعها، مع الالتزام بالجودة، والسرعة في التنفيذ، والأسعار التنافسية، وبناء شراكات مستدامة مبنية على الثقة والمصداقية."
          : "Delivering professional procurement services with quality, speed, competitive pricing, and sustainable partnerships built on trust.",
      },
      {
        key: "vision2030",
        icon: Building2,
        title: isArabic ? "رؤية 2030" : "Vision 2030",
        text: isArabic
          ? "ندعم مستهدفات رؤية المملكة 2030 عبر رفع كفاءة سلاسل الإمداد، التحول الرقمي، وتعزيز جودة الخدمات."
          : "We support Vision 2030 through efficient supply chains, digital transformation, and higher service quality.",
        points: isArabic
          ? [
              "رفع كفاءة سلاسل الإمداد وتعزيز موثوقية عمليات التوريد.",
              "تبنّي حلول حديثة وتطوير الخدمات بما يتماشى مع التحول الرقمي.",
              "الإسهام في تعزيز التنافسية وجودة الخدمات للقطاعين العام والخاص.",
              "دعم الاقتصاد الوطني بخدمات توريد ذات معايير عالية.",
            ]
          : [
              "Improve supply chain efficiency and reliability.",
              "Adopt modern solutions aligned with digital transformation.",
              "Enhance competitiveness and service quality for both sectors.",
              "Support the national economy with high-standard procurement.",
            ],
      },
      {
        key: "vision",
        icon: Eye,
        title: isArabic ? "رؤيتنا" : "Our Vision",
        text: isArabic
          ? "أن نكون الجهة الرائدة والموثوقة في توريد المتطلبات بجودة عالية وحلول متكاملة للقطاعين الحكومي والخاص داخل المملكة."
          : "To be the leading and trusted source of integrated high-quality supply solutions in the Kingdom.",
      },
    ],
    projects: {
      title: isArabic ? "أعمالنا وقطاعات الخدمة" : "Our Work & Sectors",
      subtitle: isArabic
        ? "نخدم قطاعات متعددة ونقدم حلول توريد مصممة لطبيعة كل عميل."
        : "We serve multiple sectors with tailored supply models for each client type.",
      processTitle: isArabic ? "آلية العمل" : "How We Work",
      processSteps: isArabic
        ? ["استلام الطلب وتحليل الاحتياج", "تجهيز العرض الأنسب", "توريد سريع ومتابعة مستمرة"]
        : ["Receive and assess requirements", "Prepare optimal quotation", "Fast delivery with ongoing follow-up"],
    },
    cleaningCatalog: {
      title: isArabic ? "كتالوج مستلزمات النظافة" : "Cleaning Supplies Catalog",
      subtitle: isArabic
        ? "تم عرض محتوى ملف PDF الخاص بمستلزمات النظافة. يمكنكم التصفح والقراءة مباشرة من داخل الصفحة."
        : "The cleaning supplies PDF content is displayed below for direct browsing.",
      openPdf: isArabic ? "فتح الملف في نافذة جديدة" : "Open PDF in new tab",
      pagesTitle: isArabic ? "محتوى الملف (صور الصفحات)" : "Catalog pages (image view)",
      loadMore: isArabic ? "عرض صفحات إضافية" : "Load more pages",
      sectionsTitle: isArabic ? "الأقسام الرئيسية داخل الملف" : "Main sections in the PDF",
      sections: cleaningSectionGroups.map((section) => section.title),
      sectionGroups: cleaningSectionGroups,
    },
    hospitalityCatalog: {
      title: isArabic ? "كتالوج لوازم الضيافة" : "Hospitality Supplies Catalog",
      subtitle: isArabic
        ? "تم عرض محتوى ملف PDF الخاص بمواد الضيافة. يمكنكم تصفح الصور والصفحات مباشرة من داخل الموقع."
        : "The hospitality PDF content is displayed below for direct browsing inside the website.",
      openPdf: isArabic ? "فتح ملف الضيافة في نافذة جديدة" : "Open hospitality PDF in new tab",
      pagesTitle: isArabic ? "محتوى ملف الضيافة (صور الصفحات)" : "Hospitality catalog pages (image view)",
      loadMore: isArabic ? "عرض صفحات إضافية" : "Load more pages",
      sectionsTitle: isArabic ? "أقسام مواد الضيافة" : "Hospitality sections",
      sections: isArabic
        ? ["المشروبات الساخنة", "الأكواب والعبوات", "مستلزمات التقديم", "المناديل والمواد الاستهلاكية"]
        : ["Hot beverages", "Cups & packs", "Serving essentials", "Tissues & consumables"],
    },
    contact: {
      title: isArabic ? "تواصل معنا" : "Contact Us",
      subtitle: isArabic
        ? "جاهزون لخدمتكم وتوفير احتياجات منشأتكم بسرعة وجودة عالية."
        : "We are ready to support your facility with fast and reliable supply services.",
      form: {
        fullName: isArabic ? "الاسم الكامل" : "Full Name",
        companyName: isArabic ? "اسم الشركة" : "Company Name",
        email: isArabic ? "البريد الإلكتروني" : "Email",
        phone: isArabic ? "رقم الهاتف" : "Phone",
        serviceInterest: isArabic ? "الخدمة المطلوبة" : "Service Interest",
        preferredContact: isArabic ? "وسيلة التواصل المفضلة" : "Preferred Contact",
        message: isArabic ? "تفاصيل الطلب" : "Message",
        submit: isArabic ? "إرسال الطلب" : "Submit Request",
        submitting: isArabic ? "جاري الإرسال..." : "Submitting...",
      },
      preferredMethods: [
        { value: "phone", label: isArabic ? "هاتف" : "Phone" },
        { value: "email", label: isArabic ? "بريد إلكتروني" : "Email" },
        { value: "whatsapp", label: isArabic ? "واتساب" : "WhatsApp" },
      ],
      success: isArabic ? "تم إرسال طلبكم بنجاح. سنتواصل معكم قريبًا." : "Your request was submitted successfully. We will contact you soon.",
      error: isArabic ? "تعذر إرسال الطلب حاليًا. يرجى المحاولة لاحقًا." : "Unable to submit your request right now. Please try again later.",
    },
    footer: {
      rights: isArabic ? "جميع الحقوق محفوظة" : "All rights reserved",
      quickLinks: isArabic ? "روابط سريعة" : "Quick Links",
      contactInfo: isArabic ? "بيانات التواصل" : "Contact Information",
    },
  };
};
